// 公共函数
import Vue from 'vue'
import * as qiniu from 'qiniu-js'
import { get } from './ajax'
import store from '@/store'
import { download } from '@/utils/download'

// import { prerenderPromise } from '@/main'

export const debounce = (fn, ms = 0) => {
  let timeoutId
  return function (...args) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn.apply(this, args), ms)
  }
}

export const throttle = (fn, wait) => {
  let updateTime = Date.now()
  return (...args) => {
    const now = Date.now()
    if (now - updateTime > wait) {
      fn.apply(this, args)
      updateTime = now
    }
  }
}

export const isEmpty = function (obj) {
  for (const key in obj) {
    return true
  }
  return false
}

export const getScrollTop = function (element) {
  if (element === window) {
    return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
  }
  return element.scrollTop
}

export const getVisibleHeight = function (element) {
  if (element === window) {
    return document.documentElement.clientHeight
  }

  return element.clientHeight
}

export const getScrollEventTarget = function (element) {
  let currentNode = element
  // bugfix, see http://w3help.org/zh-cn/causes/SD9013 and http://stackoverflow.com/questions/17016740/onscroll-function-is-not-working-for-chrome
  while (
    currentNode &&
    currentNode.tagName !== 'HTML' &&
    currentNode.tagName !== 'BODY' &&
    currentNode.nodeType === 1
  ) {
    const overflowY = getComputedStyle(currentNode).overflowY
    if (overflowY === 'scroll' || overflowY === 'auto') {
      return currentNode
    }
    currentNode = currentNode.parentNode
  }
  return window
}

export const getElementTop = function (element) {
  if (element === window) {
    return getScrollTop(window)
  }
  return element.getBoundingClientRect().top + getScrollTop(window)
}
export const getComputedStyle = Vue.prototype.$isServer
  ? {}
  : document.defaultView.getComputedStyle

export const importSvg = function (resolve) {
  const cache = {}
  resolve.keys().forEach((key) => {
    const component = resolve(key)
    component.name = key.slice(2).replace('.', '-')
    cache[key] = component
  })
  return Object.freeze(cache)
}

/**
 *
 * @param {*} file 文件实例
 * @param {*} options
 * @param {*} options.bucket_type 上传公库还是私库 1：公库 0：私库
 * @param {*} options.progressCb  进度条回调
 * @param {*} options.mimeType  允许的上传文件类型
 */
export const qiniuUpload = async (
  file,
  {
    bucket_type = 1,
    progressCb,
    uploadCb,
    errorCb,
    // mimeType = null,
    mimeType = [
      'image/png',
      'image/jpeg',
      'image/gif',
      'image/jpg',
      'image/bmp',
      'image/webp',
      'video/webm'
    ],
    path = 'eduTest/upload',
    noLimitToType = false
  } = {}
) => {
  const sufix = getFileSufix(file.name)
  const token_url = `/home/exams/qiniu/token`
  const params = {
    type: sufix || '',
    bucket_type
  }
  if (!params.type) {
    delete params.type
  }
  const response = await get(token_url, params)
  const host = response.bucket_url
  const putExtra = {
    fname: '',
    params: {},
    mimeType
  }
  if (!params.type) {
    // 若识别不出文件类型，去掉上传类型限制
    delete putExtra.mimeType
  }
  // 默认对类型有限制，当参数noLimitToType为true时，对类型不做限制
  if (noLimitToType) {
    delete putExtra.mimeType
  }
  const config = {
    useCdnDomain: true, // 表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
    region: qiniu.region.z0 // 根据具体提示修改上传地区,当为 null 或 undefined 时，自动分析上传域名区域
  }
  let fileName = ''
  const urlSuffix = sufix ? '.' + sufix : ''
  if (store.state.user.id) {
    fileName = `${CONFIG.iris}/${path}/${store.state.user.id}/${Date.parse(
      new Date()
    )}${urlSuffix}`
  } else {
    fileName = `${CONFIG.iris}/${path}/${Date.parse(new Date())}${urlSuffix}`
  }
  const observable = qiniu.upload(
    file,
    fileName,
    response.token,
    putExtra,
    config
  )
  return new Promise((resolve, reject) => {
    observable.subscribe({
      next: (res) => {
        // 主要用来展示进度
        if (progressCb) progressCb(res)
      },
      error: (e) => {
        reject(e)
        if (errorCb) {
          errorCb(e)
        }
        console.log('qiniuUploadError', e)
      },
      complete: (res) => {
        // 接收成功后返回的信息
        const fileName = 'https://' + host + '/' + res.key
        resolve(fileName)
        if (uploadCb) {
          uploadCb(res)
        }
      }
    })
  })
}
export const getFileSufix = (filename) => {
  const arr = filename.split('.')
  return arr[arr.length - 1]
}

// export const loadComponentWithPrerender = res => {
//   return async function() {
//     await prerenderPromise
//     return res
//   }
// }

export function set_cookie(options) {
  const { name, value, domain, max_age } = options
  const cookieString = `${name}=${value}; domain=${domain}; max-age=${max_age}; path=/;`
  const sameSiteCookie = cookieString + ' samesite=none; secure'

  document.cookie = cookieString
  document.cookie = sameSiteCookie
}

export function get_cookie(name) {
  const cookies = {}
  document.cookie.split(';').forEach((cookie) => {
    const first_equal_mark_position = cookie.indexOf('=')
    const key = cookie.slice(0, first_equal_mark_position)
    const value = cookie.slice(first_equal_mark_position + 1)
    cookies[key.trim()] = value
  })
  return cookies[name]
}

export function clear_cookie(name, domain) {
  set_cookie({
    name: name,
    value: '',
    domain: domain,
    max_age: -999999
  })
}

export function is_cookie_exist(cookie) {
  return cookie && cookie !== 'undefined' && cookie !== ''
}

// 删除空对象属性
export const deleteEmptyObj = (obj) => {
  // console.log(Object.keys(obj))
  Object.keys(obj).forEach((key) => {
    if (!obj[key] && obj[key] !== 0 && obj[key] !== '') {
      delete obj[key]
    }
  })
}

export const getChrome = () => {
  const is64 = isWin64()
  const platform = getPlatform()
  switch (platform) {
    case 'win':
      return is64
        ? 'https://static.codemao.cn/whitepaw/download/chrome_installer.exe'
        : 'https://static.codemao.cn/whitepaw/download/chrome.exe'
    case 'xp':
      return is64
        ? 'https://down.codemao.cn/forwin/chrome/chrome-49.exe'
        : 'https://static.codemao.cn/whitepaw/download/chrome.exe'
    case 'mac':
      return 'https://static.codemao.cn/whitepaw/download/googlechrome.dmg'
  }
}

export const isWin64 = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  return (
    userAgent.includes('win64') ||
    userAgent.includes('wow64') ||
    navigator.platform === 'Win64'
  )
}

export const getPlatform = () => {
  const os = detectOS()
  switch (os) {
    case 'Win7':
    case 'Win8':
    case 'Win10':
      return 'win'
    case 'WinXP':
      return 'xp'
    case 'Mac':
      return 'mac'
    default:
      return ''
  }
}

// 判断操作系统
export const detectOS = () => {
  const sUserAgent = navigator.userAgent
  const isWin =
    navigator.platform === 'Win32' || navigator.platform === 'Windows'
  const isMac =
    navigator.platform === 'Mac68K' ||
    navigator.platform === 'MacPPC' ||
    navigator.platform === 'Macintosh' ||
    navigator.platform === 'MacIntel'
  if (isMac) return 'Mac'
  const isUnix = navigator.platform === 'X11' && !isWin && !isMac
  if (isUnix) return 'Unix'
  const isLinux = String(navigator.platform).indexOf('Linux') > -1
  if (isLinux) return 'Linux'
  if (isWin) {
    const isWin2K =
      sUserAgent.indexOf('Windows NT 5.0') > -1 ||
      sUserAgent.indexOf('Windows 2000') > -1
    if (isWin2K) return 'Win2000'
    const isWinXP =
      sUserAgent.indexOf('Windows NT 5.1') > -1 ||
      sUserAgent.indexOf('Windows XP') > -1
    if (isWinXP) return 'WinXP'
    const isWin2003 =
      sUserAgent.indexOf('Windows NT 5.2') > -1 ||
      sUserAgent.indexOf('Windows 2003') > -1
    if (isWin2003) return 'Win2003'
    const isWinVista =
      sUserAgent.indexOf('Windows NT 6.0') > -1 ||
      sUserAgent.indexOf('Windows Vista') > -1
    if (isWinVista) return 'WinVista'
    const isWin7 =
      sUserAgent.indexOf('Windows NT 6.1') > -1 ||
      sUserAgent.indexOf('Windows 7') > -1
    if (isWin7) return 'Win7'
    const isWin8 =
      sUserAgent.indexOf('Windows NT 6.2') > -1 ||
      sUserAgent.indexOf('Windows NT 6.3') > -1 ||
      sUserAgent.indexOf('Windows NT 6.4') > -1 ||
      sUserAgent.indexOf('Windows NT 6.5') > -1 ||
      sUserAgent.indexOf('Windows 8') > -1
    if (isWin8) return 'Win8'
    const isWin10 =
      sUserAgent.indexOf('Windows NT 10.0') > -1 ||
      sUserAgent.indexOf('Windows 10') > -1
    if (isWin10) return 'Win10'
  }
  return 'other'
}

export const Color = {
  hexToRgb: (hex) => {
    const rgb = []
    hex = hex.replace(/[^0-9A-Za-z]/, '') // 去除多余符号
    if (hex.length === 3) {
      // 处理 "abc" 成 "aabbcc"
      hex = hex.replace(/(.)/g, '$1$1')
    }
    hex.replace(/../g, (color) => {
      rgb.push(parseInt(color, 0x10)) // 按16进制将字符串转换为数字
    })
    return rgb
  },
  rgbToHsl: ([r, g, b]) => {
    r /= 255
    g /= 255
    b /= 255
    const max = Math.max(r, g, b)
    const min = Math.min(r, g, b)
    let h = 0
    let s = 0
    const l = (max + min) / 2

    if (max === min) {
      h = s = 0
    } else {
      const d = max - min
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0)
          break
        case g:
          h = (b - r) / d + 2
          break
        case b:
          h = (r - g) / d + 4
          break
      }
      h /= 6
    }
    return [h, s, l]
  },
  hexToHsl: (hex) => {
    return Color.rgbToHsl(Color.hexToRgb(hex))
  }
}

// 下载文件，不限类型
export const downloadData = (url) => {
  download(url)
}

export const isNemoApp = () => {
  return navigator.userAgent.toLocaleUpperCase().includes('CMCODEMAO_WEBVIEW')
}

/**
 * 文件大小带单位
 * @method sizeFilter
 * @param {Number} size 文件大小
 * @param {Number} [pointLength=2] 精确到的小数点数。
 * @param {Array} [units=[ 'B', 'K', 'M', 'G', 'TB' ]] 单位数组。从字节，到千字节，一直往上指定。如果单位数组里面只指定了到了K(千字节)，同时文件大小大于M, 此方法的输出将还是显示成多少K.
 */
export const sizeFilter = (size, pointLength, units) => {
  let unit
  units = units || ['B', 'K', 'M', 'G', 'T']
  while ((unit = units.shift()) && size > 1024 && units.length) {
    size = size / 1024
  }
  return (
    (unit === 'B'
      ? size
      : size.toFixed(pointLength === 0 ? 0 : pointLength || 2)) + unit
  )
}

// 设置游客模式的信息
export const setTouristsVal = (bol) => {
  const val = bol ? '1' : '0'
  window.sessionStorage.setItem('TOURISTSTEST', val)
}

export const getTouristsVal = () => {
  const bol = window.sessionStorage.getItem('TOURISTSTEST')
  const val = Number(bol)
  return !!val
}

// 设置游客token的值
export const setTouristsToken = (val) => {
  window.localStorage.setItem('TOURISTSTOKEN', val)
}

export const getTouristsToken = () => {
  return window.localStorage.getItem('TOURISTSTOKEN')
}

export const removeTouristsToken = () => {
  window.localStorage.removeItem('TOURISTSTOKEN')
}

export const setRealTouristsToken = (val) => {
  window.localStorage.setItem('REALTOURISTSTOKEN', val)
}

export const getRealTouristsToken = () => {
  return window.localStorage.getItem('REALTOURISTSTOKEN')
}

export const removeRealTouristsToken = () => {
  window.localStorage.removeItem('REALTOURISTSTOKEN')
}

// 设置游客userId的值
export const setTouristsUserId = (val) => {
  window.localStorage.setItem('TOURISTSUSERID', val)
}

export const getTouristsUserId = () => {
  return window.localStorage.getItem('TOURISTSUSERID')
}

export const removeTouristsUserId = () => {
  window.localStorage.removeItem('TOURISTSUSERID')
}

// 判断是否在深空定制课App
export const isInDzkApp = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  return (
    userAgent.includes('codemaster-octopus-client') &&
    userAgent.includes('electron')
  )
}

// 判断是否是wrc比赛
export const isWrcTest = () => {
  const wrcs = window.CONFIG.wrc_station
  console.log('wrcs', wrcs)
  let bool = false
  for (let i = 0; i < wrcs.length; i++) {
    if (location.href.includes(wrcs[i])) {
      bool = true
      break
    }
  }
  return bool
}
/**
 *
 * @param {number} ms
 * @returns
 */
export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

// 判断是否是cpp比赛
export const isCppTest = () => {
  const bool = sessionStorage.getItem('isCpp')
  return bool
}

/**
 * 获取考试id
 * @returns {string} 考试id
 */
export const getExamId = () => {
  const queryExamId = new URLSearchParams(location.search).get('examId')
  if (queryExamId) {
    try {
      localStorage.setItem('examId', queryExamId)
    } catch (e) {
      // localStorage储存已满或用户禁用localStorage可能会报错
      console.error('getExamId error', e)
    }
    return queryExamId
  }
  return localStorage.getItem('examId')
}

export const resolveUploadFileUrl = (entireUrl) => {
  const urlWithoutProtocol = entireUrl.replace(/^https?:\/\//i, '')
  const urlSplitList = urlWithoutProtocol.split('/')
  const splitListLen = urlSplitList.length
  let startIndex = 3
  if (CONFIG.env === 'production') {
    startIndex = 2
  }
  return urlSplitList.slice(startIndex, splitListLen).join('/')
}
